import React, { useState, useEffect } from 'react';
import {
  ListItem, List
} from '@mui/material';
import { useSnackbar } from 'notistack';
import FormFieldFactory from 'components/Form/FormFieldFactory';
import useLoading from 'context/LoadingContext';
import SnackMessage from 'components/SnackMessage/SnackMessage';
import { VITE_PORTAL_API } from 'config';
import useConnectErrorHandler from 'helpers/errorHandlers';
import { post, put } from 'helpers/query/fetchers';
import Form from 'components/Form/Form';
import API from 'common/api';

const initialFormValue = {
  name: '',
};

const initialFormErrorValue = {
  name: [],
};

const CompanyCreate = ({
  title, button, data = null, formType = 'create', refetch = null
}) => {
  const [form, setForm] = useState(initialFormValue);
  const [formError, setFormError] = useState(initialFormErrorValue);
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = useLoading();
  const { handleError } = useConnectErrorHandler();

  useEffect(() => {
    if (data) {
      setForm({ name: data.name });
      setFormError(initialFormErrorValue);
    }
    return () => { };
  }, [data]);

  const onChangeValue = (value, name) => {
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (handleClose, setSubmitting) => {
    setLoading(true);
    setSubmitting(true);
    const payload = JSON.parse(JSON.stringify(form));

    let url;
    let msg = '';
    if (formType === 'create') {
      url = `${VITE_PORTAL_API}${API.COMPANY}`;
      post(url, payload)
        .then((result) => {
          handleClose(true);
          setForm(initialFormValue);
          setFormError(initialFormErrorValue);
          setSubmitting(false);
          refetch();
          msg = `Company: ${result.data.name} has been Created.`;
          enqueueSnackbar(msg, {
            content: (key) => <SnackMessage id={key} message={msg} variant="success" />
          });
        })
        .catch((error) => {
          setLoading(false);
          setSubmitting(false);
          setFormError(error.response.data);
          handleError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (formType === 'update') {
      url = `${VITE_PORTAL_API}${API.COMPANY}${data.id}/`;
      put(url, payload)
        .then((result) => {
          handleClose(true);
          setForm(initialFormValue);
          setFormError(initialFormErrorValue);
          setSubmitting(false);

          setForm(result.data);
          msg = `Company: ${result.data.id} has been Updated.`;
          refetch();
          enqueueSnackbar(msg, {
            content: (key) => <SnackMessage id={key} message={msg} variant="success" />
          });
        })
        .catch((error) => {
          setLoading(false);
          setSubmitting(false);
          setFormError(error.response.data);
          handleError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const isError = (error) => error && error.length > 0;

  const renderForm = () => (
    <List disablePadding>
      <ListItem disableGutters>
        <FormFieldFactory
          type="string"
          key="name"
          name="name"
          label="name"
          // maxLength={fields.name.max_length}
          value={form.name}
          onChange={onChangeValue}
          autoFocus
          required
          error={isError(formError.name)}
          helperText={formError.name ? formError.name[0] : null}
        />
      </ListItem>
    </List>
  );

  return (
    <Form title={title} button={button} renderForm={renderForm} submitForm={handleSubmit} />
  );
};

export default CompanyCreate;
